export * from "./update-dataset-value"
export * from "./with-props-validation"

/**
 * Defer importing a def view function until it's called
 *
 * There are some limitations in webpack around dynamic expressions, and so we
 * need to have the view base be a known path like `../`
 *
 * https://webpack.js.org/guides/migrating/#dynamic-expressions
 *
 * @param {String} path Path to view module (relative to entry root)
 */

function importDeferredView(path) {
  return (el, props) => {
    return import(`../${path}/index.ts`).then(f => f.default(el, props))
  }
}
function importDeferredViewTsx(path) {
  return (el, props) => {
    return import(`../${path}/index.tsx`).then(f => f.default(el, props))
  }
}

export default {
  analyticsPageView: importDeferredView("analytics/page-view"),
  analyticsEvent: importDeferredView("analytics/event"),
  analyticsGlobalEvents: importDeferredView("analytics/global-events"),
  analyticsSegmentLoader: importDeferredView("analytics/segment-loader"),
  analyticsTrackLink: importDeferredView("analytics/track-link"),
  analyticsIdentifyAndTrackLink: importDeferredView(
    "analytics/identify-and-track-link"
  ),
  analyticsWistiaEvents: importDeferredView("analytics/wistia-events"),
  lazyLoad: importDeferredView("lazy-load"),
  masthead: importDeferredView("masthead"),
  mastheadSimplified: importDeferredView("masthead-simplified"),
  backgroundVideoControls: importDeferredView("background-video-controls"),
  companyValuesList: importDeferredView("company-values-list"),
  backgroundColorChangeOnScroll: importDeferredView(
    "background-color-change-on-scroll"
  ),
  podcastEpisodeToggle: importDeferredView("podcast-episode-toggle"),
  salesToggle: importDeferredView("sales-toggle"),
  podcastSubscribeToggle: importDeferredView("podcast-subscribe-toggle"),
  testimonialCarousel: importDeferredView("testimonial-carousel"),
  tabs: importDeferredView("tabs"),
  productBlock: importDeferredView("product-block"),
  filters: importDeferredView("filters"),
  localizedDateTime: importDeferredView("localized-date-time"),
  pricingTable: importDeferredView("pricing-table"),
  collapsible: importDeferredView("collapsible"),
  logoSetRows: importDeferredView("logo-set-rows"),
  dropdown: importDeferredView("dropdown"),
  videoModal: importDeferredView("video-modal"),
  ribbon: importDeferredView("ribbon"),
  componentLibraryMasthead: importDeferredView("component-library-masthead"),
  articlesSearch: importDeferredViewTsx("articles-search"),
  careersListing: importDeferredViewTsx("careers-listing"),
  podcastCloseTranscript: importDeferredView("podcast-close-transcript"),
  stickyFilter: importDeferredView("sticky-filter"),
  tableOfContents: importDeferredView("table-of-contents"),
  adSpots: importDeferredView("ad-spots"),
  openSingleDetail: importDeferredView("open-single-detail"),
  openDetailsOnSearch: importDeferredView("open-details-on-search"),
}
